import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { Countries } from '@models/countries.model';
import { Observable } from 'rxjs';
import { dataLoaderContext } from 'tangoe-design-system';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  constructor(private http: HttpClient) {}

  getCountries(key?: string, param?: object): Observable<Countries> {
    return this.http.get<Countries>(StoreEndpointsConstant.COUNTRIES, {
      params: { ...param },
      context: dataLoaderContext(key ?? 'country-list')
    });
  }
}
